export default {"name":"NovaComponents-WindowShade-gui-icu","comments":[],"messages":{"NovaComponents-WindowShade-gui-icu.header.required.aria":"required"}}